// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/usage.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";

/**
 * Resolution specifies the time granularity for time series data.
 *
 * @generated from enum gitpod.v1.Resolution
 */
export enum Resolution {
  /**
   * @generated from enum value: RESOLUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOLUTION_HOURLY = 1;
   */
  HOURLY = 1,

  /**
   * @generated from enum value: RESOLUTION_DAILY = 2;
   */
  DAILY = 2,

  /**
   * @generated from enum value: RESOLUTION_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * @generated from enum value: RESOLUTION_MONTHLY = 4;
   */
  MONTHLY = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(Resolution)
proto3.util.setEnumType(Resolution, "gitpod.v1.Resolution", [
  { no: 0, name: "RESOLUTION_UNSPECIFIED" },
  { no: 1, name: "RESOLUTION_HOURLY" },
  { no: 2, name: "RESOLUTION_DAILY" },
  { no: 3, name: "RESOLUTION_WEEKLY" },
  { no: 4, name: "RESOLUTION_MONTHLY" },
]);

/**
 * DateRange specifies a time period for queries.
 *
 * @generated from message gitpod.v1.DateRange
 */
export class DateRange extends Message<DateRange> {
  /**
   * Start time of the date range (inclusive).
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * End time of the date range (exclusive).
   *
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  constructor(data?: PartialMessage<DateRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DateRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DateRange {
    return new DateRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJsonString(jsonString, options);
  }

  static equals(a: DateRange | PlainMessage<DateRange> | undefined, b: DateRange | PlainMessage<DateRange> | undefined): boolean {
    return proto3.util.equals(DateRange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.TimeSeriesPoint
 */
export class TimeSeriesPoint extends Message<TimeSeriesPoint> {
  /**
   * Timestamp for this data point.
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * The numerical value for this data point.
   *
   * @generated from field: int32 value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<TimeSeriesPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.TimeSeriesPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimeSeriesPoint {
    return new TimeSeriesPoint().fromJsonString(jsonString, options);
  }

  static equals(a: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined, b: TimeSeriesPoint | PlainMessage<TimeSeriesPoint> | undefined): boolean {
    return proto3.util.equals(TimeSeriesPoint, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersCountRequest
 */
export class GetActiveUsersCountRequest extends Message<GetActiveUsersCountRequest> {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  constructor(data?: PartialMessage<GetActiveUsersCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_range", kind: "message", T: DateRange },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersCountRequest {
    return new GetActiveUsersCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersCountRequest | PlainMessage<GetActiveUsersCountRequest> | undefined, b: GetActiveUsersCountRequest | PlainMessage<GetActiveUsersCountRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersCountRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersCountResponse
 */
export class GetActiveUsersCountResponse extends Message<GetActiveUsersCountResponse> {
  /**
   * Count of active users in the date range.
   *
   * @generated from field: int64 count = 1;
   */
  count = protoInt64.zero;

  /**
   * Trend of active users compared to the previous date_range in %. Calculated as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend = 0;

  constructor(data?: PartialMessage<GetActiveUsersCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "trend", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersCountResponse {
    return new GetActiveUsersCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersCountResponse | PlainMessage<GetActiveUsersCountResponse> | undefined, b: GetActiveUsersCountResponse | PlainMessage<GetActiveUsersCountResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersCountResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersRequest
 */
export class GetTopActiveUsersRequest extends Message<GetTopActiveUsersRequest> {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;

  constructor(data?: PartialMessage<GetTopActiveUsersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "pagination", kind: "message", T: PaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersRequest {
    return new GetTopActiveUsersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersRequest | PlainMessage<GetTopActiveUsersRequest> | undefined, b: GetTopActiveUsersRequest | PlainMessage<GetTopActiveUsersRequest> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse
 */
export class GetTopActiveUsersResponse extends Message<GetTopActiveUsersResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * List of users sorted by total runtime (descending).
   *
   * @generated from field: repeated gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo users = 2;
   */
  users: GetTopActiveUsersResponse_UserRuntimeInfo[] = [];

  constructor(data?: PartialMessage<GetTopActiveUsersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "users", kind: "message", T: GetTopActiveUsersResponse_UserRuntimeInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse {
    return new GetTopActiveUsersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersResponse | PlainMessage<GetTopActiveUsersResponse> | undefined, b: GetTopActiveUsersResponse | PlainMessage<GetTopActiveUsersResponse> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo
 */
export class GetTopActiveUsersResponse_UserRuntimeInfo extends Message<GetTopActiveUsersResponse_UserRuntimeInfo> {
  /**
   * User ID.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * User name if available.
   *
   * @generated from field: string user_name = 2;
   */
  userName = "";

  /**
   * User avatar if available.
   *
   * @generated from field: string user_avatar_url = 3;
   */
  userAvatarUrl = "";

  /**
   * Total environment runtime in seconds.
   *
   * @generated from field: double total_runtime_seconds = 4;
   */
  totalRuntimeSeconds = 0;

  constructor(data?: PartialMessage<GetTopActiveUsersResponse_UserRuntimeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_runtime_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTopActiveUsersResponse_UserRuntimeInfo {
    return new GetTopActiveUsersResponse_UserRuntimeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GetTopActiveUsersResponse_UserRuntimeInfo | PlainMessage<GetTopActiveUsersResponse_UserRuntimeInfo> | undefined, b: GetTopActiveUsersResponse_UserRuntimeInfo | PlainMessage<GetTopActiveUsersResponse_UserRuntimeInfo> | undefined): boolean {
    return proto3.util.equals(GetTopActiveUsersResponse_UserRuntimeInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesRequest
 */
export class GetActiveUsersTimeSeriesRequest extends Message<GetActiveUsersTimeSeriesRequest> {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution = Resolution.UNSPECIFIED;

  constructor(data?: PartialMessage<GetActiveUsersTimeSeriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersTimeSeriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "resolution", kind: "enum", T: proto3.getEnumType(Resolution) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesRequest {
    return new GetActiveUsersTimeSeriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersTimeSeriesRequest | PlainMessage<GetActiveUsersTimeSeriesRequest> | undefined, b: GetActiveUsersTimeSeriesRequest | PlainMessage<GetActiveUsersTimeSeriesRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersTimeSeriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesResponse
 */
export class GetActiveUsersTimeSeriesResponse extends Message<GetActiveUsersTimeSeriesResponse> {
  /**
   * Weekly active users time series [WAU]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_users = 1;
   */
  weeklyActiveUsers: TimeSeriesPoint[] = [];

  /**
   * Weekly active returning users time series [WAU2+]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_returning_users = 2;
   */
  weeklyActiveReturningUsers: TimeSeriesPoint[] = [];

  constructor(data?: PartialMessage<GetActiveUsersTimeSeriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetActiveUsersTimeSeriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "weekly_active_users", kind: "message", T: TimeSeriesPoint, repeated: true },
    { no: 2, name: "weekly_active_returning_users", kind: "message", T: TimeSeriesPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveUsersTimeSeriesResponse {
    return new GetActiveUsersTimeSeriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveUsersTimeSeriesResponse | PlainMessage<GetActiveUsersTimeSeriesResponse> | undefined, b: GetActiveUsersTimeSeriesResponse | PlainMessage<GetActiveUsersTimeSeriesResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveUsersTimeSeriesResponse, a, b);
  }
}

